

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form8";
const form8State = namespace("Form8");

import { form8SearchInfoType, orderInfoDataType } from '@/types/Information/Form8';
import { chambersHearingJsonInfoType, partiesDataJsonDataType } from '@/types/Information/json';
import Spinner from "@/components/utils/Spinner.vue";

@Component({
    components: {           
        Spinner
    }        
}) 
export default class Form8CaseInformation extends Vue {

    @informationState.Action
    public UpdatePartiesJson!: (newPartiesJson: partiesDataJsonDataType) => void

    @form8State.Action
    public UpdateCurrentOrder!: (newCurrentOrder: chambersHearingJsonInfoType) => void
    
    @informationState.Action
    public UpdateFileNumber!: (newFileNumber: string) => void
    
    @form8State.Action
    public UpdateCurrentNoticeOfApplicationToVaryId!: (newCurrentNoticeOfApplicationToVaryId: string) => void
    
    levelOfCourt = "Court of Appeal";

    fileNumberState = true;
    partyState = true;

    dataReady = false;
    searching = false;
    resultsReady = false;

    searchParams = {} as form8SearchInfoType;
    notFound = false;
    orders: chambersHearingJsonInfoType[] = [];

    orderFields =  
    [
        {
            key:'ScheduleDate',          
            label:'Judgment Date',                  
            thClass: 'text-white bg-court',
            thStyle: 'font-size: 1rem;',            
            sortable:false            
        }, 
        {
            key:'JudgeFullName',          
            label:'Judge Full Name',   
            thClass: 'text-white bg-court', 
            thStyle: 'font-size: 1rem;',          
            sortable:false            
        }, 
        {
            key:'edit',          
            label:'',   
            thClass: 'text-white bg-court',           
            sortable:false            
        }     
    ];
    partyOptions = [
        {text: 'Individual', value: 'Individual'},
        {text: 'Organization', value: 'Organization'}
    ];

    mounted(){
        this.fileNumberState = true;
        this.partyState = true;
        this.dataReady = false;
        this.resultsReady = false;
        this.orders = [];
        this.searching = false;
        this.dataReady = true; 
    }

    public selectOrder(courtOrder: chambersHearingJsonInfoType){
        this.UpdateCurrentOrder(courtOrder);
        this.UpdateCurrentNoticeOfApplicationToVaryId(null);            
        this.$router.push({name: "fill-form8"});
    }

    public otherOrder(){
        this.UpdateCurrentOrder(null);
        this.UpdateCurrentNoticeOfApplicationToVaryId(null);            
        this.$router.push({name: "fill-form8"});
    }

    public extractInfo(courtOrders: chambersHearingJsonInfoType[]){

        let orders: orderInfoDataType[] = [];
        orders = courtOrders;

        for(const orderInx in orders){
            //console.log(orderInx)
            orders[orderInx].JudgeFullName = orders[orderInx].JudgeLastName? 
                ('The Honourable ' +  
                (orders[orderInx].JudgeSalutation? orders[orderInx].JudgeSalutation + ' ':'Justice ') + 
                (orders[orderInx].JudgeFirstName? orders[orderInx].JudgeFirstName + ' ':'' )+ 
                (orders[orderInx].JudgeLastName? orders[orderInx].JudgeLastName:''))
                :'UNKNOWN';
        }

        return orders;        
    }

    public findFile(){

        this.searching = true;        
        this.notFound = false;
        this.fileNumberState = true;
        this.partyState = true;
        this.orders = [];

        if(!this.searchParams.file){
            this.fileNumberState = false;
            this.searching = false;
            return
        }

        if(!this.searchParams.searchBy){
            this.partyState = false;
            this.searching = false;
            return
        }
        
        const url = '/form7s/?'+
            'caseNumber='+(this.searchParams.file?this.searchParams.file:'')+
            '&firstName='+(this.searchParams.firstName?this.searchParams.firstName:'')+
            '&lastName='+(this.searchParams.lastName?this.searchParams.lastName:'')+
            '&searchBy='+(this.searchParams.searchBy?this.searchParams.searchBy:'')+
            '&organizationName='+(this.searchParams.organizationName?this.searchParams.organizationName:'')+
            '&addChambersHearing=True'; 
        
        this.resultsReady = true;
        
        this.$http.get(url)
        .then(res => {
            if (res.data){

                if(res.data?.parties){
                    this.UpdatePartiesJson(res.data.parties);
                    this.UpdateFileNumber(this.searchParams.file)                
                }

                if(res.data?.chambersHearing){
                    this.orders = this.extractInfo(res.data?.chambersHearing);                    
                }               
               

            } else {
                this.notFound = true;
            }
            this.searching = false;
            Vue.filter('scrollInto')('results-table')            
            
        },err => {
            console.error(err); 
            this.notFound = true;
            this.searching = false;
        });        
    }
}
